module.exports = __webpack_public_path__ + "assets/building-left.be4359ec.svg";